import { Outlet } from 'react-router-dom'

// Screens with nowhere to navigate to: sign in and 404. No chrome, because
// there is nothing for chrome to point at.
export default function AuthShell() {
  return (
    <div
      className="min-h-screen min-h-[100dvh] flex flex-col"
      style={{
        paddingTop: 'max(44px, env(safe-area-inset-top))',
        paddingBottom: 'max(24px, env(safe-area-inset-bottom))',
      }}
    >
      <main className="flex-1 flex flex-col px-6">
        <Outlet />
      </main>
    </div>
  )
}
